<template>
    <div>
        <div v-if="!bind_wechat" class='home'>
            <div class="layout">
                <div ref="qrCode" id="qrCode" class="qr-code">
                    <canvas ref="sqdl"></canvas>
                    <p class="title">请使用微信扫码授权绑定</p>
                    <!-- <p>{{ contractUrl }}</p> -->
                </div>
            </div>
        </div>
        <div v-else class='home'>
            <div class="layout">
                <div style="font-size: 14px">
                    当前账户已绑定微信，<el-link type="primary" @click="changebinding">我要换绑</el-link>
                </div>
                <div class="layout_tx"><img :src="wechat_header" alt=""></div>
                <div>{{ wechat_nick }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
     import common from '@/utils/common'
    import { useOrgConfig } from '@/utils/useUserConfig.js';
    export default {
      data() {
        return {
          qqqrcodema: '',
          myOrgConfig: {},
          contractUrl: '',
          userInfo: {},
          loginTimer: null,
          bind_wechat: false,
          wechat_header: '',
          wechat_nick: ''
        }
      },
      created() {
        
      },
      async mounted() {
        this.myOrgConfig = await useOrgConfig()
        this.getUserInfo()

      },
      computed: {
        ...mapState(['org_id']),
      },
      methods: {
        changebinding() {
            this.$confirm('你确定要更换绑定么?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.bind_wechat = false
                this.getLoginCode()
            })
        },
        getLoginCode() {
            this.$liveApi.get("/liveapi/wap/login/getLoginCode", { timeout: 5000 })
            .then((res2) => {
            if (res2.data.code == 200) {
                this.qqqrcodema = res2.data.data.code;
                console.log('21231===', this.qqqrcodema, this.myOrgConfig)
                this.showQrcode(this.qqqrcodema, this.myOrgConfig);
                this.loginTimer = setInterval( () => {
                    this.checkCodeStatus(this.qqqrcodema)
                }, 3000);
            }
            })
        },
        checkCodeStatus(qqqrcodema) {
            this.$liveApi.post("/liveapi/wap/login/checkCodeStatus", {code:qqqrcodema})
                .then( res => {
                  if (res.data.code == 200) {
                    if (res.data.data.status == 3) {
                      clearInterval(this.loginTimer);
                      this.loginTimer = null;
                      this.userInfo = res.data.data.fans_data;
                      this.bindWechat(this.userInfo.fans_id)
                      console.log('userInfo===', this.userInfo )
                    }
                  }
                });
        },
        showQrcode(qqqrcodema, myOrgConfig) {
            this.contractUrl = `${myOrgConfig.wechat_auth_domain}/login/#/wx-pc-login?qrcode=${qqqrcodema}&appId=${myOrgConfig.official_account_appid}&uId=${this.org_id}&origin=shanhu`
            console.log('codeUrl==1', this.contractUrl)
            this.$nextTick(() => {
                console.log('22222', this.$refs.sqdl)
                common.createQrCode(this.$refs.sqdl, this.contractUrl, { width: 250, height: 250 })
            })
        },
        // 网校学员绑定微信
        bindWechat(fans_id) {
            const data = {
                fans_id: fans_id,
            }
            this.$axios.post('/user/index/bindThirdParty', data).then((res) => {
                console.log('3111====', res)
                if (res.data.code === 200) {
                    this.getUserInfo()
                    this.$message({
                        message: '绑定成功',
                        type: 'success',
                    })
                } else {
                    // document.getElementById('qrCode').innerHTML = '';
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                    this.getLoginCode()
                }
            })
        },
        // 获取用户信息
        getUserInfo() {
            this.$axios.post('/user/index/getUserInfo').then((res) => {
                if (res.data.code === 200) {
                    this.bind_wechat = res.data.data.bind_wechat
                    this.wechat_header = res.data.data.wechat_header
                    this.wechat_nick = res.data.data.wechat_nick
                    if (!this.bind_wechat) {
                        this.getLoginCode()
                    } else {
                        clearInterval(this.loginTimer);
                        this.loginTimer = null;
                    }
                }
            })
        },
      },
    }
</script>
<style lang='scss' scoped>
.home {
    .layout {
        width: 480px;
        height: 100%;
        margin: auto;
        overflow: hidden;
        text-align: center;
        background: #ffffff;
        // &::-webkit-scrollbar {
        //     display: none;
        // }
        // iframe {
        //     width: 100%;
        //     height: 100%;
        // }
        .qr-code {
            margin-top: 10vh;
        }
        .title {
            font-size: 26px;
        }
        .layout_tx img {
            width: 100px;
            height: 100px;
            border-radius: 50px;
            margin-top: 20px;
        }
    }
}
</style>